import {Component, ViewChild, ViewChildren} from '@angular/core';

import { RouterModule, Routes } from '@angular/router';
import {MenuItem} from 'primeng/primeng';

import {MamLoginComponent} from'./mam_login.component'
import {MamContentsComponent} from'./mam_contents.component'


import {CompanyManagerPageComponent} from './page/system/company_mgr.page';
import {FrontMainComponent} from "./page/main/front_main";
import {DeviceConditionComponent} from "./page/device/device_condition";
import {AppManagementComponent} from "./page/device/app_management";
import {DeviceStatisticsComponent} from "./page/device/device_statistics";
import {CertManagementComponent} from "./page/device/cert_management";
import {RemoteManagementComponent} from "./page/device/remote_management";
import {DeviceLocationInfoComponent} from "./page/device/device_location_info";
import {PolicyConfigNewComponent} from "./page/policy/policy_config_new";
import {PolicyConfigLocationComponent} from "./page/policy/policy_config_location";
import {PolicyApplyConditionNewComponent} from "./page/policy/policy_apply_condition_new";
import {PolicyResourceComponent} from "./page/policy/policy_resource";
import {PolicyScheduleComponent} from "./page/policy/policy_schedule";
import {InstallationLogComponent} from "./page/log/installation_log";
import {LostManagementComponent} from "./page/log/lost_management";
import {IssueLogComponent} from "./page/log/issue_log";
import {AuditLogComponent} from "./page/log/audit_log";
import {NoticeManagementComponent} from "./page/system/notice_management";
import {DeviceUserManagementComponent} from "./page/system/device_user_management";
import {DeviceTypeManagementComponent} from "./page/system/device_type_management";
import {UserAgreementManagementComponent} from "./page/system/user_agreement_management";
//import {DeptManagementComponent} from "./page/system/dept_management";
import {AdminManagementComponent} from "./page/system/admin_management";
import {SystemSettingComponent} from "./page/system/system_setting";
import {CompanyTreeComponent} from "./page/device/company_tree";
import {LogComponent} from "./page/log/log";
import {SetupStateLogComponent} from "./page/log/setup_state_log";
import {UsbStorageLogComponent} from "./page/log/usb_storage_log";
import {OfficeAppLogComponent} from "./page/log/office_app_log";
import {VisitorLogStatisticsComponent} from "./page/visitor/visitor_log_statistics";
import {VisitorManagementComponent} from "./page/visitor/visitor_management";
import {HeartBeatLogComponent} from "./page/log/heartbeat_log";
import {OTPHistoryComponent} from "./page/log/otp_history";
import {DBSyncLogComponent} from "./page/log/dbSync_log";

import {TranslateServiceForm, TRANSLATIONS} from './translate';
import {getViewClassName} from "@angular/compiler/src/view_compiler/util";
import * as glob from "./service/global_url";
import {EmergencyLogComponent} from "./page/log/emergency_log";


@Component({
  selector: 'app-menu-vertical',
  templateUrl : 'mam_app_vertical.menu.html'
})
export class MamMenuVerticalComponent {
    @ViewChild('nav1') nav1:any;
    @ViewChild('nav2') nav2:any;
    @ViewChild('nav3') nav3:any;
    @ViewChild('nav4') nav4:any;
    @ViewChild('nav5') nav5:any;

    @ViewChild('m1') m1:any;
    @ViewChild('m2') m2:any;
    @ViewChild('m3') m3:any;
    @ViewChild('m4') m4:any;
    @ViewChild('m5') m5:any;
    @ViewChild('m6') m6:any;

    @ViewChild('s1') s1:any;
    @ViewChild('subNav1') subNav1:any;

    private kyungnamIsTrue : boolean = glob.kyungnamIsTrue;
    private dtaqIsTrue : boolean = glob.dtaqIsTrue;

    constructor (private _translate: TranslateServiceForm) {

    }
    private items: MenuItem[];
     ngOnInit() {

       
       this.items = [
         {
           label: this._translate.instant('LANG_TOP_gotoMain'),
           icon: 'fa-home',
           routerLink : ['home']
         },
         {
           label: this._translate.instant('LANG_TOP_DeviceManagement'),
           icon: 'fa-mobile',
           routerLink : ['./home/device'],
           items: [
             {label: this._translate.instant('LANG_DEVICE_TotalStatus'),  routerLink: ['./home/device/deviceCondition']},
             {label: this._translate.instant('LANG_DEVICE_AppManagement'),  routerLink: ['./home/device/appManagement']},
             /*{label: this._translate.instant('LANG_APP_PresentCondition'),  routerLink: ['./home/device/deviceStatistics']},*/
             /*{label: '인증서 관리', routerLink: ['./home/device/certManagement']},*/
             {label: this._translate.instant('LANG_DeviceRemoteManage'), routerLink: ['./home/device/remoteManagement'] },
             {label: this._translate.instant('LANG_DEVICE_PositionInfomation'), routerLink: ['./home/device/deviceLocationInfo']}
           ]
         },
         {
           label: this._translate.instant('LANG_ManagePolicy'),
           icon: 'fa-life-ring',
           routerLink : ['home/policy'],
           /*url : '/policy',*/
           items: [
             {label: this._translate.instant('LANG_POLICY_PolicyConfig'), routerLink: ['home/policy/policyConfigNew']},
             {label: this._translate.instant('LANG_POLICY_PolicyConfigPassing'), routerLink: ['home/policy/policyConfigLocation']},
             {label: this._translate.instant('LANG_POLICY_PolicyApplyStatus'), routerLink: ['home/policy/policyApplyConditionNew']},
             {label: this._translate.instant('LANG_POLICY_PolicyResources'), routerLink: ['home/policy/policyResource']},
             /*{label: '정책전송예약', routerLink: ['home/policy/policySchedule']}*/
             /*{label: '휴일 관리', routerLink: ['policy/holidayManagement']}*/
           ]
         },
         {
           label: this._translate.instant('LANG_TOP_StatisticsLog'),
           icon: 'fa-bar-chart',
           routerLink : ['home/log'],
           items: [
             {label: this._translate.instant('LANG_LOG_InstallLog'), routerLink: ['home/log/OTPHistory']},
             {label: this._translate.instant('LANG_LOG_InstallLog'), routerLink: ['home/log/installationLog']},
             {label: this._translate.instant('LANG_LOG_LostManagement'), routerLink: ['home/log/lostManagement']},
             {label: this._translate.instant('LANG_LOG_IssueLog'), routerLink: ['home/log/issueLog']},
             {label: this._translate.instant('LANG_LOG_HbLog'), routerLink: ['home/log/hbLog']},
             {label: this._translate.instant('LANG_LOG_AuditLog'), routerLink: ['home/log/auditLog']},
             {label: this._translate.instant('LANG_LOG_AuditLog'), routerLink: ['home/log/dbSyncLog']},
             {label: this._translate.instant('LANG_LOG_DeviceLog'), routerLink: ['home/log/deviceLog'], items: [
               {label : this._translate.instant('LANG_LOG_LogManagement'), routerLink:['home/log/deviceLog/log']},
               {label : this._translate.instant('AL_EmergencyUnlockOK'), routerLink:['home/log/deviceLog/emergencyLog']},
               {label : this._translate.instant('AL_Install_Remove_Log'), routerLink:['home/log/deviceLog/setupStateLog']},
               {label : this._translate.instant('AL_UsbStorageLog'), routerLink:['home/log/deviceLog/usbStorageLog']},
               {label : this._translate.instant('AL_OfficeAppLog'), routerLink:['home/log/deviceLog/officeAppLog']},
             ]}
           ]
         },
         {
           label: this._translate.instant('LANG_TOP_Settings'),
           icon: 'fa-cog',
           routerLink : ['./home/system'],
           items: [
             {label: this._translate.instant('LANG_SETTING_NoticeManagement'), routerLink: ['home/system/noticeManagement']},
             {label: this._translate.instant('LANG_SETTING_UserAgreementManagement'), routerLink: ['home/system/userAgreementManagement']},
             {label: this._translate.instant('LANG_SETTING_DeviceTypeManagement'), routerLink: ['home/system/deviceTypeManagement']},
             {label: this._translate.instant('LANG_SETTING_DeviceUserManagement'), routerLink: ['home/system/deviceUserManagement']},
             {label: this._translate.instant('LANG_SETTING_DeptManagement'), routerLink: ['home/system/companyManagement']},
             {label: this._translate.instant('LANG_SETTING_AdminManagement'), routerLink: ['home/system/adminManagement']},
             {label: this._translate.instant('LANG_SETTING_SystemSettings'), routerLink: ['home/system/systemSetting']}
             /*{label: 'Manager', routerLink: ['home/manager']}*/
             //{label: 'Company', routerLink: ['system/company']}
           ]
         },
         {
           label: this._translate.instant('LANG_Visitor_Header_GNB'),
           icon: 'fa-child',
           routerLink : ['./home/visitor'],
           items: [
             /*{label: '방문자 예약관리', routerLink: ['home/visitor/visitorManagement']},*/
             {label: this._translate.instant('LANG_Visitor_Header_GNB'), routerLink: ['home/visitor/visitorLogStatistics']}
           ]
         }
       ];
     }
     parentMenuClick(index,event){
       let navs : any= [this.nav1,this.nav2,this.nav3,this.nav4,this.nav5];
       let ms : any = [this.m1,this.m2,this.m3,this.m4,this.m5,this.m6];
       for(let i=0; i<6; i++){
          if(index-1 == i){
            console.debug("test",navs[i]);
            if(ms[i].nativeElement.className.includes("open")){
                if(i!=5){ navs[i].nativeElement.className="navN"; }
                ms[i].nativeElement.className = ms[i].nativeElement.className.replace(" ","").replace("open","");
            }else{
                if(i!=5){ navs[i].nativeElement.className="navB"; }
                event.target.className = event.target.className += " open";
            }
          }else{
            if(i!=5){ navs[i].nativeElement.className="navN"; }
            ms[i].nativeElement.className = ms[i].nativeElement.className.replace(" ","").replace("open","");
          }
       }

     }

    logSubMenuClick(event){
         if(this.s1.nativeElement.className.includes("active")){
             this.s1.nativeElement.className = this.s1.nativeElement.className.replace(" ","").replace("active","");
             this.subNav1.nativeElement.className="submenuList navN";
         }else{
             this.s1.nativeElement.className += " active";
             this.subNav1.nativeElement.className="submenuList navB";
         }
    }
}

const routes: Routes = [
    { path: '',  pathMatch: 'full' ,redirectTo : 'login'},
    { path: 'login',component : MamLoginComponent},
    { path: 'home', component : MamContentsComponent, children : [
      { path: '', component : FrontMainComponent },
      {path: 'device', children : [
        {path : '', pathMatch : 'full', redirectTo : 'deviceCondition'},
        {path : 'deviceCondition', component : DeviceConditionComponent},
        {path : 'appManagement', component : AppManagementComponent},
        /*{path : 'deviceStatistics', component : DeviceStatisticsComponent},*/
        /*{path : 'certManagement', component : CertManagementComponent},*/
        {path : 'remoteManagement', component : RemoteManagementComponent},
        {path : 'deviceLocationInfo', component : DeviceLocationInfoComponent}
     ]},
     {path: 'policy', children : [
        {path : '', pathMatch : 'full', redirectTo : 'policyConfigNew'},
        {path : 'policyConfigNew',component : PolicyConfigNewComponent},
        {path : 'policyConfigLocation',component : PolicyConfigLocationComponent},
        {path : 'policyApplyConditionNew',component : PolicyApplyConditionNewComponent},
        {path : 'policyResource',component : PolicyResourceComponent},
        {path : 'policySchedule',component : PolicyScheduleComponent}
        /*{path : 'holidayManagement',component : HolidayManagementComponent},*/
      ]},
      {path: 'log', children : [
        {path : '', pathMatch : 'full', redirectTo : 'installationLog'},
        {path : 'OTPHisotry',component : OTPHistoryComponent},
        {path : 'installationLog',component : InstallationLogComponent},
        {path : 'lostManagement',component : LostManagementComponent},
        {path : 'issueLog',component : IssueLogComponent},
        {path : 'auditLog',component : AuditLogComponent},
        {path : 'dbSyncLog',component : DBSyncLogComponent},
        {path : 'deviceLog', children : [
          {path : '', redirectTo : 'log', pathMatch : 'full' },
          {path : 'log', component : LogComponent  },
          {path : 'emergencyLog', component : EmergencyLogComponent  },
          {path : 'setupStateLog', component : SetupStateLogComponent  },
          {path : 'usbStorageLog', component : UsbStorageLogComponent },
          {path : 'officeAppLog', component :  OfficeAppLogComponent },
          
        ]}
      ]},
      { path: 'system',children : [
        {path : '', pathMatch : 'full', redirectTo : 'noticeManagement'},
        {path : 'noticeManagement',component : NoticeManagementComponent},
        {path : 'userAgreementManagement',component : UserAgreementManagementComponent},
        {path : 'deviceTypeManagement',component : DeviceTypeManagementComponent},
        {path : 'deviceUserManagement',component : DeviceUserManagementComponent},
        //{path : 'deptManagement',component : DeptManagementComponent},
        {path : 'adminManagement',component : AdminManagementComponent},
        {path : 'systemSetting',component : SystemSettingComponent},
        {path: 'companyManagement', component: CompanyManagerPageComponent},
        {path: 'manager', component: CompanyManagerPageComponent}

       ]},
      { path: 'visitor',children : [
        {path : '', pathMatch : 'full', redirectTo : 'visitorLogStatistics'},
        {path : 'visitorManagement',component : VisitorManagementComponent},
        {path : 'visitorLogStatistics',component : VisitorLogStatisticsComponent}

      ]}
    ]}
  ];

export const MamRoutingModule = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/mam_app_vertical.menu.ts